// Package imports:
import React from 'react';
import cx from 'classnames';

// Component imports:
import Icon from '../../Header/CustomIcon/CustomIcon';
// Service imports:
import useComponentVisible from '../../../services/hooks';
// Type imports:
import { ICompanyViewModel } from '../../../types/CompanyTypes';
import Tooltip from '../../../ui-elements/Tooltip/Tooltip';


const KYCNavBar: React.FC<ICompanyViewModel> = () => {

    const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible();

    return (
        <div className="KCL_sub-navbar">
            <ul className="mobileMenu">
                <li>
                    <span className='list-category' id="mobile" onClick={() => setIsComponentVisible(!isComponentVisible)}>
                        Áreiðanleikakannanir (KYC) <Icon type='dropdown-arrow' />
                    </span>
                    <ul ref={ref} className={cx("mobile dropdown", { "focused": isComponentVisible })}>
                        <li><a href={`/Areidanleikakannanir/Yfirlit`}>Áreiðanleikakannanir (KYC)</a></li>
                        <li className='list'>
                            <span>AML vöktun</span>
                            <ul className='list-items'>
                                <li><a href={`/Valistar/Leit#AML-vaktin`}>AML vaktin</a></li>
                                {/* CHANGE THIS LINK */}
                                <li className='disabled'><span className="disabled">Atburðaskrá / tilkynningar</span></li>
                            </ul>
                        </li>
                        <li><a href={`/Valistar/Leit#Island`}>Stjórnmálaleg tengsl</a></li>
                        <li className='list'>
                            <span>Alþjóðlegir válistar</span>
                            <ul className='list-items'>
                                <li><a href={`/Valistar/Leit#Althjodlegt-Einstaklingar`}>Alþjóðlegir válistar einstaklingar</a></li>
                                <li><a href={`/Valistar/Leit#Althjodlegt-Logadilar`}>Alþjóðlegir válistar lögaðilar</a></li>
                            </ul>
                        </li>
                        <li><a href={`/Areidanleikakannanir/Leidbeiningar`}>Leiðbeiningar</a></li>
                    </ul>
                </li>
            </ul>
            <ul className='itemList'>
                <li><a className='list-category' href={`/Areidanleikakannanir/Yfirlit`}>Áreiðanleikakannanir (KYC)</a></li>
                <li>
                    <span className='list-category'>AML vöktun <span className='icon'><Icon type='dropdown-arrow' /></span></span>
                    <ul className="dropdown">
                        <li><a href={`/Valistar/Leit#AML-vaktin`}>AML vaktin</a></li>
                        {/* CHANGE THIS LINK */}

                        <li className='disabled'><Tooltip noUnderline text={<span className='disabled'>Atburðaskrá / tilkynningar</span>} tooltip={"Væntanlegt"} /></li>
                    </ul>
                </li>
                <li><a className='list-category' href={`/Valistar/Leit#Island`}>Stjórnmálaleg tengsl</a></li>
                <li>
                    <span className='list-category' >Alþjóðlegir válistar <span className='icon'><Icon type='dropdown-arrow' /></span></span>
                    <ul className="dropdown">
                        <li><a href={`/Valistar/Leit#Althjodlegt-Einstaklingar`}>Alþjóðlegir válistar einstaklingar</a></li>
                        <li><a href={`/Valistar/Leit#Althjodlegt-Logadilar`}>Alþjóðlegir válistar lögaðilar</a></li>
                    </ul>
                </li>
                <li><a className='list-category' href={`/Areidanleikakannanir/Leidbeiningar`}>Leiðbeiningar</a></li>
            </ul>
        </div>
    )
}

export default KYCNavBar;

